import { XMarkIcon } from "@heroicons/react/24/outline";

const CloseIcon = ({ onClick }) => (
  <div className="h-10 w-10 relative cursor-pointer" onClick={onClick}>
    <XMarkIcon className="stroke-gray-600 dark:stroke-gray-300 hover:stroke-gray-800 dark:hover:stroke-gray-100 h-5 w-5 absolute top-3 bottom-3 right-0" />
  </div>
);

export default CloseIcon;
